module.exports = {
  // 应用id
  appId: '900010',

  title: 'SIJIN',

  hostDomain: 'geekyum'
}
